import { Component, OnInit } from '@angular/core';
import { ParametreGeneral } from '../../core/model/ParametreGeneral';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ParametreGeneralService } from '../../core/service/parametre-general.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { first } from "rxjs/operators";

@Component({
  selector: "app-add-parametre-general",
  templateUrl: "./add-parametre-general.component.html",
  styleUrls: ["./add-parametre-general.component.scss"]
})
export class AddParametreGeneralComponent implements OnInit {
  parametreGeneral: ParametreGeneral = new ParametreGeneral();

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _parametreGeneralService: ParametreGeneralService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      codeParametre: [null, Validators.compose([Validators.required])],
      libelleParametre: [null, Validators.compose([Validators.nullValidator])],
      valeurParametre: [null, Validators.compose([Validators.required])],
      typeParametre: [null, Validators.compose([Validators.required])]
    });
  }

  ngOnInit() {}

  save(): void {
    this.pressButton = true;
    this.parametreGeneral = this.form2.value;
    this._parametreGeneralService
      .add(this.parametreGeneral)
      .pipe(first())
      .subscribe(
        data => {
          this.pressButton = false;
          this.activeModal.close();
        },
        error => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
